import { c as _c } from "react/compiler-runtime";
// Morfi wordmark for OG cards.
//
// Path data is inlined verbatim from `frontend/public/assets/logo-white.svg`
// (viewBox `0 0 679 223`). Inlining is the Satori-friendly pattern: Satori
// renders `<svg>`/`<path>` natively and never needs to fetch the asset.
// Always white fill — every OG shell renders against a dark frame.
//
// `size` is the wordmark HEIGHT in pixels; width follows the 679:223
// source aspect ratio. Pick `logoSize` in `shell-tokens.ts`.
//
// If the upstream wordmark in `/assets/logo-white.svg` changes, copy the
// new `<path d="..."/>` elements over here in the same order. The fill
// stays `#ffffff` regardless of the source colour.

const WORDMARK_ASPECT_RATIO: number = 679 / 223;
const WORDMARK_FILL: string = '#ffffff';
interface OgLogoProps {
  /** Wordmark height in pixels. Width follows the 679:223 source aspect. */
  size: number;
}
export function OgLogo(t0) {
  const $ = _c(10);
  const {
    size
  } = t0;
  let t1;
  if ($[0] !== size) {
    t1 = Math.round(size * WORDMARK_ASPECT_RATIO);
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const width = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M540.054 51.3521C540.054 17.3274 559.272 0 594.557 0H617.87V35.2849H599.282C587.941 35.2849 582.9 40.6406 582.9 51.6671V62.0636H617.24V96.4033H582.9V222.106H540.054V96.4033H522.418V62.0636H540.054V51.3521ZM634.882 40.3225V0H678.989V40.3225H634.882ZM635.513 222.106V62.0636H678.358V222.106H635.513Z" fill={WORDMARK_FILL} />;
    t4 = <path d="M461.124 222H415V62L460.5 62.0002C460.96 73.5002 459.438 80.6268 452.083 99.9468L454.994 101.48C470.931 68.5135 486.031 64.9135 513 62.0002V96.5002C465.957 99.5668 461.124 110.067 461.124 155.3V222Z" fill={WORDMARK_FILL} />;
    t5 = <path d="M45.5933 222H0V63.5651H45.1388C45.5933 73.0712 43.7756 81.5211 36.8079 101.439L39.6858 102.948C55.5905 71.7132 69.8289 61 91.338 61C115.271 61 126.48 76.9944 120.572 103.4L123.602 104.456C135.568 74.2784 152.533 61 177.223 61C203.428 61 216 75.6364 216 105.664V222H170.407V113.661C170.407 100.081 165.105 92.9888 154.957 92.9888C139.658 92.9888 130.872 111.699 130.872 138.558V222H85.2791V113.812C85.2791 100.533 79.6746 92.8379 69.9804 92.8379C55.136 92.8379 45.5933 110.945 45.5933 139.01V222Z" fill={WORDMARK_FILL} />;
    t6 = <path d="M328.289 60.9268C324.281 60.3169 320.177 60 316 60C315.36 60 314.723 60.0087 314.088 60.0225C302.381 60.2937 291.287 63.0493 281.314 67.7818L285.795 94.775C286.834 101.035 280.861 106.166 274.829 104.193L248.847 95.693C242.544 105.016 238.131 115.723 236.16 127.262C235.731 129.763 235.419 132.306 235.227 134.881C235.13 136.167 235.065 137.462 235.03 138.765C235.01 139.507 235 140.252 235 141C235 142.495 235.039 143.978 235.119 145.452C237.43 188.117 272.76 222 316 222C328.274 222 339.909 219.269 350.334 214.383L345.739 186.766C344.698 180.503 350.675 175.37 356.708 177.347L383.316 186.062C391.958 173.178 397 157.678 397 141C397 100.443 367.193 66.8468 328.289 60.9268ZM316 96.3912C319.508 96.3912 322.908 96.93 326.141 97.9365C322.986 120.986 302.594 139.076 277.261 140.855C277.327 116.286 294.647 96.3912 316 96.3912ZM283.05 164.469C314.954 163.969 341.228 141.589 345.813 112.515C351.387 120.241 354.739 130.169 354.739 141C354.739 165.636 337.394 185.608 316 185.608C302.083 185.608 289.88 177.157 283.05 164.469Z" fill={WORDMARK_FILL} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== size || $[8] !== width) {
    t7 = <svg width={width} height={size} viewBox="0 0 679 223" xmlns="http://www.w3.org/2000/svg" style={t2} role="img" aria-label="Morfi">{t3}{t4}{t5}{t6}</svg>;
    $[7] = size;
    $[8] = width;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}